

import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { PATH } from '../../config';
import { useSelector } from 'react-redux'; 

const AuthGuard = ({ children }) => {
  const location = useLocation();

  const { user } = useSelector((state) => state.user);

  const isAuthenticated = user && user.token;

  if (isAuthenticated) {
  
    return <>{children}</>;
  } else {
 
    return <Navigate to={PATH.LOGIN} state={{ from: location }} replace />;
  }
};

export default AuthGuard;